import { api } from "../../App";
import {
  SET_STUDENTS_LIST,
  SET_GROUPS_LIST,
  SET_STUDENTS_LIST_FOR_GENERAL_INFO,
  SET_STUDENTS_LIST_FOR_GENERAL_INFO_EXPELLED,
  SET_STUDENTS_BASE_INFO,
  SET_STUDENTS_LOADING
} from "../types";



export const getStudents = (params) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(params).toString();
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students?${urlParams}`)
    dispatch({ type: SET_STUDENTS_LIST, payload: data })
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

//оригинальный запрос на группы перегруженный = поэтому новый тут
export const getGroupsForStudents = (params) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(params).toString();
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/groups?${urlParams}`)
    dispatch({ type: SET_GROUPS_LIST, payload: data.groups })
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// classbook tabs Классный журнал
// НА СТОРОНЕ БЭКА СЛОЖНО СОВМЕСТИТЬ -ЗАПРОС ДОЛГИЙ
// СТУДЕНТЫ ТЕКУЩИЕ
export const getStudentsForGeneralInfo = (params) => async (dispatch, getState) => {
  try {
    const { scYear: xp_key, dropouts: status, scYear: year } = params // дополнительный год для запроса да
    const para = status === 0 ? { year } : { xp_key, status: 'expelled' }
    const urlParams = new URLSearchParams(para).toString();

    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/students?${urlParams}`)
    dispatch({ type: SET_STUDENTS_LIST_FOR_GENERAL_INFO, payload: data })
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// ОТЧИСЛЕННЫЕ ???? 
export const getExpelledStudentsForGeneralInfo = ({ }) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get('/students?${urlParams}')
    dispatch({ type: SET_STUDENTS_LIST_FOR_GENERAL_INFO_EXPELLED, payload: data })
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

// Личные дела учащихся = для всех вкладок массив
export const getStudentBaseInfo = (studentId) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    const { data } = await api.get(`/xp_personal_file/base/${studentId}`)
    dispatch({ type: SET_STUDENTS_BASE_INFO, payload: data })
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};
export const createStudentBaseInfo = (studentId) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.post(`/xp_personal_file/base/${studentId}`)
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};
export const updateStudentBaseInfo = (studentId, base) => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_STUDENTS_LOADING, payload: true });
    await api.put(`/xp_personal_file/base/${studentId}`, base)
    dispatch(getStudents())
  } catch (ERR) {
    console.log(ERR)
  } finally {
    dispatch({ type: SET_STUDENTS_LOADING, payload: false });
  }
};

